import './polyfills';

import * as Sentry from '@sentry/react';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import { CONFIG } from 'src/config-global';

Sentry.init({
  environment: CONFIG.sentryEnv,
  dsn: CONFIG.sentryDsn,
});

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />);
});
